import { Tooltip as AntTooltip } from 'antd';
import type { TooltipProps } from 'antd';

export const DarwinTooltip = (props: TooltipProps) => {
  return <AntTooltip {...props} />;
};
